var map = {
	"./airconditioning.svg": 3676,
	"./book.svg": 9316,
	"./camera.svg": 8854,
	"./chef.svg": 27,
	"./cleaning.svg": 5410,
	"./clipboard.svg": 5543,
	"./computer.svg": 8588,
	"./cords.svg": 5574,
	"./croissant.svg": 8309,
	"./datashow.svg": 1864,
	"./drinks.svg": 7774,
	"./equipe.svg": 18,
	"./fixService.svg": 309,
	"./fixing.svg": 7764,
	"./food.svg": 6463,
	"./laptop-error.svg": 446,
	"./laptop.svg": 4667,
	"./mail.svg": 9814,
	"./network.svg": 2603,
	"./network2.svg": 4307,
	"./notes.svg": 8810,
	"./papers.svg": 1566,
	"./projector.svg": 7333,
	"./radio.svg": 3656,
	"./security.svg": 861,
	"./service.svg": 1712,
	"./soda.svg": 4724,
	"./tea.svg": 7367,
	"./tripod.svg": 2079,
	"./usb.svg": 7879,
	"./video.svg": 7680,
	"./water.svg": 8604,
	"./wifi.svg": 5460
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 527;